'use es6';

import http from 'hub-http/clients/apiClient';
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
import get from 'transmute/get';
import always from 'transmute/always';
const BASE_URL = '/ctas/v2/cta-to-placements';
export const createGetPlacementById = ({
  httpClient
}) => ids => httpClient.get(`${BASE_URL}`, {
  query: {
    ctaGuid: ids
  }
}).then(formatToReferencesList({
  getId: get('cta_guid'),
  getLabel: always('cta-to-placement')
}));
export const getPlacementById = createGetPlacementById({
  httpClient: http
});